_BannerFlowApp.directive("explorer", function ($timeout) {
    return {
        restrict: "A",
        replace: false,
        link: function (scope, element, attrs, ngModel) {
            var watcher = scope.$watch("$data", function (n, o) {
                if (!n) return;

                init();
            });

            var destroyDraggable = function (u) {
                var draggable_data = u.data("draggable");
                u.draggable("destroy");
                u.data("draggable", draggable_data || {});
            };

            var deselectAll = function () {
                $("tr.ui-selected", element).removeClass("ui-selected");
                destroyDraggable($("tr.ui-draggable", $(element)));
                scope.$apply(function () {
                    scope.$parent[attrs.explorerOnSelection]([]);
                });
            };

            var x = function (e) {
                if (
                    !$(e.target).parents("table.table").size() &&
                    !$(e.target).is(".table-toolbar") &&
                    !$(e.target).parents(".table-toolbar").size() &&
                    !$(e.target).is(".ngdialog") &&
                    !$(e.target).parents(".ngdialog").size()
                ) {
                    deselectAll();
                    $(window).off("mousedown", x);
                }
            };

            var createDraggables = function () {
                $("tr.ui-selected", $(element)).draggable({
                    helper: function (event) {
                        return $(
                            "<div class='explorer-draggable-helper'><span>{0}</span></div>".format(
                                $("tr.ui-selected", $(element)).length
                            )
                        );
                    },
                    cursorAt: {
                        left: -10,
                        top: -10
                    }
                });
            };

            var createLinkDraggables = function () {
                $timeout(function () {
                    if ($("a", $(element)).length) {
                        $("a", $(element)).draggable({
                            delay: 250,
                            start: function (e, ui) {
                                var tr = $(e.target).closest("tr").first();
                                tr.toggleClass("ui-selected", true);
                            },
                            helper: function (event) {
                                return $(
                                    "<div class='explorer-draggable-helper'><span>{0}</span></div>".format(
                                        Math.max($("tr.ui-selected", $(element)).length, 1)
                                    )
                                );
                            },
                            cursorAt: {
                                left: -10,
                                top: -10
                            }
                        });
                    }
                }, 100);
            };

            var createDroppables = function () {
                //Make rows droppables
                $("tbody tr.is-folder", element).droppable({
                    hoverClass: "ui-state-highlight",
                    tolerance: "pointer",
                    drop: function (event, ui) {
                        var that = this;
                        var link = false;
                        var conflict = false;
                        var objects = [];
                        var folder = angular.element(that).scope().row.id;

                        $("tr.ui-selected", $(element)).each(function () {
                            if ($(that).is(this)) {
                                conflict = true;
                            }

                            var row = angular.element(this).scope().row;
                            objects.push(row);
                        });

                        if (!conflict) {
                            scope.$apply(function () {
                                scope.$parent[attrs.explorerOnDrop](folder, objects);
                            });

                            if ($(ui.draggable).is("a"))
                                $($(ui.draggable).closest("tr").first(), $(element)).remove();
                            else $("tr.ui-selected", $(element)).remove();

                            ui.draggable.detach();

                            deselectAll();
                        }
                    }
                });
            };

            var init = function () {
                var isDragging = false;

                // Handle drag/click logic
                $("tbody tr", element)
                    .mousedown(function (e) {
                        isDragging = false;
                        if (!$(e.target).is(".edit-link") && !$(e.target).is("input"))
                            $("input[type=text]").blur();
                    })
                    .mousemove(function () {
                        isDragging = true;
                    })
                    .mouseup(function (e) {
                        var wasDragging = isDragging;
                        isDragging = false;

                        if (!wasDragging && !$(e.target).is("a") && !e.shiftKey) {
                            var target = $(e.target).parent("tr.ui-selected");

                            if (!e.metaKey && !e.ctrlKey) {
                                $("tr.ui-selected", element).removeClass("ui-selected");
                            }

                            try {
                                destroyDraggable($("tr.ui-draggable", $(element)));
                            } catch (e) {}

                            if (target.length) {
                                target.toggleClass("ui-selected", "true");
                                $("tbody", element).data("ui-selectable")._mouseStop(null);
                            }
                        }

                        $(window).on("mousedown", x);
                    })
                    .dblclick(function (e) {
                        if ($(e.target).is("input")) return;

                        if ($(this).is(".is-folder")) {
                            $("a.folder", this).first().trigger("click");
                        } else {
                            $("a:not(.folder)", this).first().trigger("click");
                        }
                    });

                var prev = -1;
                //Make rows selectable & draggable
                $("tbody", element).selectable({
                    cancel: "a, input",
                    stop: function () {
                        var objects = [];
                        $("tr.ui-selected", $(element)).each(function () {
                            var row = angular.element(this).scope().row;

                            objects.push(row);
                        });

                        scope.$apply(function () {
                            scope.$parent[attrs.explorerOnSelection](objects);
                        });
                    },
                    selecting: function (e, ui) {
                        var curr = $(ui.selecting.tagName, e.target).index(ui.selecting);
                        if (e.shiftKey && prev > -1) {
                            console.log(prev, curr, Math.min(prev, curr));
                            $(ui.selecting.tagName, e.target)
                                .slice(Math.min(prev, curr), 1 + Math.max(prev, curr))
                                .addClass("ui-selected");
                            prev = -1;
                        } else {
                            prev = curr;
                        }
                    },
                    unselected: function (event, ui) {
                        $(ui.unselected).removeClass("click-selected");
                    },
                    selected: function (event, ui) {
                        $(window).on("mousedown", x);

                        try {
                            destroyDraggable($("tr.ui-draggable", $(element)));
                        } catch (e) {}

                        createDraggables();
                        createDroppables();
                    }
                });

                $timeout(function () {
                    createLinkDraggables();
                    createDroppables();
                });
            };

            scope.$on("$destroy", function () {
                watcher();
            });

            init();
        }
    };
});
